import React from 'react';

const FilesList = ({ attachments, onDelete }) => {
  const handleDelete = (attachmentId) => {
    if (window.confirm('Are you sure?')) {
      onDelete(attachmentId);
    }
  };

  return <>
    {attachments.length > 0 && (
      <div className="my-4">
        <p className="font-semibold text-slate-600 uppercase mb-2">Existing Attachments</p>
        <div className="flex flex-row gap-x-2">
          {attachments.map((attachment) => (
            <div key={attachment.id} className="flex flex-col gap-y-2">
              <div className="flex flex-col">
                <a href={attachment.url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={attachment.url}
                    alt={attachment.filename}
                    style={{ height: '200px', width: '200px', objectFit: 'contain' }}
                  />
                </a>
                <p>{attachment.filename}</p>
              </div>
              <button
                onClick={() => handleDelete(attachment.id)}
                className="btn btn-red"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      </div>
    )}
  </>
}

export default FilesList
